<script>
  import SearchableList from "$lib/components/SearchableList.svelte";

  export let lowTierContributors;
  export let errorMessage;
  export let errorId;

  $: filteredItems = [...lowTierContributors];
  function onSearch(event) {
    // handles error for empty search input
    let searchedName = event.detail["donorSearch-searchableList-searchBar"];
    if (!searchedName) {
      errorMessage = "Please enter a first or last name.";
      errorId = "donorSearch-error-emptyValue";
      return;
    }
    filteredItems = lowTierContributors.filter(({ name }) =>
      name?.toLowerCase().includes(searchedName.toLowerCase())
    );
    // handles error when no results are found in search
    if (filteredItems.length === 0) {
      errorMessage = "Sorry, we can't find that name.";
      errorId = "donorSearch-error-noResults";
    } else {
      // clear error
      errorMessage = "";
      errorId = "";
    }
  }

  function resetContributorList() {
    errorMessage = "";
    errorId = "";
    filteredItems = [...lowTierContributors];
  }
</script>

<div id="lowTierContributorList">
  <SearchableList
    title={"$200 to $9,999"}
    description={"Donors"}
    searchBarPlaceholder={"Search for a donor"}
    items={filteredItems}
    on:submit={onSearch}
    formName={"donorSearch"}
    {errorId}
    {errorMessage}
    handleClear={resetContributorList}
  />
</div>
